import Angular from "angular";
import Controller from "./new-booking-resource.controller";
import Template from "./new-booking-resource.html";
import Servies from "../../services/services.service";
import Resources from "../../services/resources.service";

export const NewBookingResourceView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.new-booking-resource', [Servies.name, Resources.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-resource/new-booking-resource.js